"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScoreBar = exports.Direction = exports.DEFAULT_COLOR_MAP = void 0;
var React = _interopRequireWildcard(require("react"));
var _invariant = _interopRequireDefault(require("invariant"));
var _clamp = _interopRequireDefault(require("lodash/clamp"));
var _color = require("../../styles/variables/_color.js");
var _size = require("../../styles/variables/_size");
var _classify = require("../../utils/classify");
var _scoreBar = require("../../utils/score-bar");
var _Text = require("../Text");
var _ScoreBarModule = _interopRequireDefault(require("./ScoreBar.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const Direction = Object.freeze({
  horizontal: 'horizontal',
  vertical: 'vertical'
});
exports.Direction = Direction;
const DEFAULT_BARS_COUNT = 5;
const DEFAULT_COLOR_MAP = {
  inactive: _color.colorScoreBarInactive,
  '100': _color.colorScoreBarLevel5,
  '80': _color.colorScoreBarLevel4,
  '60': _color.colorScoreBarLevel3,
  '40': _color.colorScoreBarLevel2,
  '20': _color.colorScoreBarLevel1
};
exports.DEFAULT_COLOR_MAP = DEFAULT_COLOR_MAP;
const ScoreBar = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    score = 0,
    colorMap = DEFAULT_COLOR_MAP,
    totalBars = DEFAULT_BARS_COUNT,
    direction = 'vertical',
    classNames,
    withBorder = false,
    labelMap
  } = _ref;
  (0, _invariant.default)(totalBars > 0, JSON.stringify(_scoreBar.SCORE_BAR_ERRORS.INVALID_BAR_COUNT));
  const activeLabel = (0, _scoreBar.getLabelByScorePercentage)(score, totalBars, labelMap);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    "data-testid": "ScoreBar",
    className: (0, _classify.classify)(_ScoreBarModule.default.scoreBarWrapper, {
      [_ScoreBarModule.default.scoreBarBorder]: withBorder
    }, classNames?.wrapper)
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.classify)(_ScoreBarModule.default.scoreBarContainer, classNames?.container),
    style: {
      '--direction': direction === Direction.horizontal ? 'row-reverse' : 'column',
      '--height': direction === Direction.horizontal ? _size.size18 : 'unset',
      '--width': direction === Direction.vertical ? _size.size18 : 'unset'
    }
  }, [...Array(totalBars).keys()].reverse().map(count => /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.classify)(_ScoreBarModule.default.bar, classNames?.bar),
    style: {
      '--background-color': (0, _scoreBar.getColorByScorePercentage)(totalBars, (0, _clamp.default)(score, 0, totalBars), count, colorMap),
      '--height': direction === Direction.horizontal ? _size.size18 : _size.size2,
      '--width': direction === Direction.vertical ? _size.size18 : _size.size2
    },
    key: count
  }))), activeLabel && /*#__PURE__*/React.createElement(_Text.SubTitleExtraSmall, {
    className: (0, _classify.classify)(_ScoreBarModule.default.scoreBarLabel, classNames?.label)
  }, activeLabel));
});
exports.ScoreBar = ScoreBar;